import { Component, OnInit } from '@angular/core';
import { BaseComponent } from '../base/base.component';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'DCO-logout.component',
  templateUrl: './logout.component.html',
  standalone: false,
})
export class LogoutComponent extends BaseComponent implements OnInit  {

  logOutUrl = environment.logOutUrl;

}
